module.exports = __webpack_public_path__ + "images/img-23.50d0f56a.jpg";